/**
 * @owner @Appboy/messaging-experience
 */
import { csvImportRemoteLookupValidators } from "../.generated/csvImportRemoteLookup";
import type { CsvImportRemoteLookupProvider } from "../.generated/csvImportRemoteLookup";

export const csvImportProvider: CsvImportRemoteLookupProvider = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: csvImportRemoteLookupValidators,
};
